import React, { useMemo } from 'react';

import type { TAPIconAstropayAliasType } from './mingcute.alias';
import type { IAPBucketMingCute } from './mingcute.type';
import type { IAPIconAstropayProps } from './types';

import APImageSVG from '../image-svg';
import { APIconsSVGCache } from './icon-db.cache';
import { _APMingCuteAliasArray } from './mingcute.alias';

const APIconAstropay: React.FC<IAPIconAstropayProps> = ({
  icon,
  color,
  size,
  fullWidth,
  aspectRatio,
  flip,
  rotate,
  style,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  subIcon,
  ...restProps
}) => {
  // Handle icon alias resolution
  const resolvedIcon = useMemo(() => {
    let _icon = icon;
    Object.keys(_APMingCuteAliasArray).forEach((key) => {
      const iconKey = _APMingCuteAliasArray[key as TAPIconAstropayAliasType];
      const find = iconKey.flatMap((item) => (item.includes(icon) ? item : [])).length > 0;
      if (find) _icon = key as IAPBucketMingCute;
    });
    return _icon;
  }, [icon]);

  return (
    <APImageSVG
      icon={resolvedIcon}
      cacheBase="icons"
      cache={APIconsSVGCache}
      color={color}
      size={size}
      fullWidth={fullWidth}
      aspectRatio={aspectRatio}
      flip={flip}
      rotate={rotate}
      style={style}
      {...restProps}
    />
  );
};
export default APIconAstropay;
